import {
  BODY_FONT,
  DATA_START_ROW,
  HEADER_FONT_11,
  HEADER_FONT_12,
  VALUE_FILL,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  addHiddenTemplateRow,
  addPrinciple2BackLink,
  addSheetTitle,
  addSimpleTableHeader,
  addTableSpacer,
  displayText,
  formatPercent,
  setupPrinciple2DetailSheet,
  writeDataRow,
  hideRowsThrough,
} from "./principle2DetailHelpers.js";

const SHEET_TITLE =
  "Reclaimed products and their packaging materials (as percentage of products sold) for each product category";

export const SHEET_NAME = "Reclaimed";

const WIDTHS = {
  A: 9.1796875,
  B: 9.1796875,
  C: 9.1796875,
  D: 7.26953125,
  E: 67.54296875,
  F: 91.453125,
  G: 9.1796875,
  H: 9.1796875,
  I: 9.1796875,
};

const HEADERS = [
  { col: COL_D, label: "Sr. No.", font: HEADER_FONT_11 },
  { col: COL_E, label: "Indicate product category", font: HEADER_FONT_12 },
  {
    col: COL_F,
    label:
      "Reclaimed products and their packaging materials as Percentage of total products sold in respective category",
    font: HEADER_FONT_11,
  },
];

export function buildReclaimedSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });
  const colEnd = COL_F;

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd,
    lastVisibleCol: 9,
    xSplit: 3,
  });
  addPrinciple2BackLink(ws, colEnd);

  addSheetTitle(ws, colEnd, SHEET_TITLE);
  addSimpleTableHeader(ws, COL_D, colEnd, HEADERS, { height: 32.25 });
  addHiddenTemplateRow(ws, COL_D, colEnd, { height: 58 });
  addTableSpacer(ws, COL_D, colEnd);

  const rows = Array.isArray(
    sectionC?.principle2?.leadershipIndicator?.reclaimedProductsPercentage
  )
    ? sectionC.principle2.leadershipIndicator.reclaimedProductsPercentage
    : [];
  const dataRows = rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(ws, row, COL_D, colEnd, [
      { col: COL_D, value: String(idx + 1), align: "center", fill: undefined, font: BODY_FONT },
      { col: COL_E, value: displayText(item?.productCategory), align: "left", fill: VALUE_FILL },
      { col: COL_F, value: formatPercent(item?.percentage), align: "center", fill: VALUE_FILL },
    ]);
    ws.getRow(row).height = 29;
  });

  hideRowsThrough(ws, 5);
  return ws;
}
